import { useState, useEffect, useCallback, useMemo } from 'react'
import Countdown, { zeroPad } from 'react-countdown'
import { useRouter } from 'next/router'

import { copyTextToClipboard } from 'helpers'

import { withUserContext } from 'context'
import { Text, ButtonSimple, Icon, CustomLink, Avatar } from 'components/common'
import { Tooltip } from 'antd';
import TimerStyle from './style'

const Timer = (props) => {

    const router = useRouter()
    const url = useMemo(() => `${process.env.NEXT_PUBLIC_APP_URL}/debate/${props.slug}`, [props.slug])
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    const twitterUrl = `https://twitter.com/intent/tweet?url=${url}`
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`

    const [toggleSharePopup, setToggleSharePopup] = useState(false)
    const [isFollow, setIsFollow] = useState(false)

    useEffect(() => {
        if (props.isLoggedIn) {
            setIsFollow(props?.user?.following?.includes(props.debateUser.id))
        }
    }, [props.user, props.isLoggedIn])

    useEffect(() => {
        if (toggleSharePopup) {
            document.addEventListener('click', clickHandler)
        }

        return () => {
            document.removeEventListener('click', clickHandler)
        }
    }, [toggleSharePopup])

    const clickHandler = useCallback((e) => {
        let isExist = e?.path.find((el) => el.classList?.contains('share-btn'))

        if (!isExist) {
            setToggleSharePopup(false)
        }
    }, [])

    const handleFollow = () => {
        if (props.isLoggedIn) {
            return props.toggleFollow(props.debateUser.id).then(() => {
                setIsFollow(!isFollow)
            })
        } else {
            router.push(`${router.asPath}?c=login`)
        }
    }

    const render = ({ days, hours, minutes, seconds, completed }) => {
        let text = []
        if (completed) {
            text = ['FI', 'NI', 'SH', 'ED'];
        } else {
            text = [zeroPad(days), zeroPad(hours), zeroPad(minutes), zeroPad(seconds)]
        }

        return (
            <div className='timer flexBoxColumn'>
                <div className='cont flexBox spaceBetween'>
                    <div className='single-time flexBoxColumn'>
                        <Text tag='h2' className='block days h2 PopSemi' text={text[0]} />
                        <Text tag='p' className='type p PopReg uppercase' text='Days' />
                    </div>
                    <div className='time flexBox'>
                        <div className='single-time flexBoxColumn'>
                            <Text tag='h2' className='block hours h2 PopSemi' text={text[1]} />
                            <Text tag='p' className='type p PopReg uppercase' text='hours' />
                        </div>
                        <Text tag='h2' className='dot h2 PopSemi' text=':' />
                        <div className='single-time flexBoxColumn'>
                            <Text tag='h2' className='block hours h2 PopSemi' text={text[2]} />
                            <Text tag='p' className='type p PopReg uppercase' text='minutes' />
                        </div>
                        <Text tag='h2' className='dot h2 PopSemi' text=':' />
                        <div className='single-time flexBoxColumn'>
                            <Text tag='h2' className='block hours h2 PopSemi' text={text[3]} />
                            <Text tag='p' className='type p PopReg uppercase' text='seconds' />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <TimerStyle className='flexBoxColumn alignMiddle'>
            <Countdown date={props.endDate} renderer={render} />
            <div className='debate-info flexBox '>
                <CustomLink url={`/${props.debateUser.username}`}>
                    <Avatar src={props.debateUser.avatar} />
                </CustomLink>
                <CustomLink url={`/${props.debateUser.username}`}>
                    <div className='info'>
                        <Text tag={'h5'} className='h5 PopSemi' text={props.debateUser.name} />
                        <Text tag={'p'} className='h7 PopReg grey' text={`${props.debateUser.debatesCount} debates created`} />
                    </div>
                </CustomLink>
            </div>
            <div className='buttons flexBox spaceBetween'>
                {props?.user?.id != props.debateUser.id && (
                    <ButtonSimple className='white purple bordered timer' onClick={handleFollow}>
                        {isFollow ?
                            <>
                                <Icon className='op-mark h6 purple' />
                                <Text tag={'p'} className={'h8 PopReg text'} text={'Following'} />
                            </>
                            :
                            <>
                                <Text tag={'p'} className={'i h6 PopReg'} text={'+ '} />
                                <Text tag={'p'} className={'h8 PopReg text'} text={'Follow'} />
                            </>
                        }
                    </ButtonSimple>
                )}

                <ButtonSimple className={`white purple bordered share-btn timer ${props?.user?.id === props.debateUser.id && 'full-width'} ${toggleSharePopup ? 'active' : ''}`} onClick={() => setToggleSharePopup(!toggleSharePopup)}>
                    <Icon className='op-share h6 purple' />
                    <Text tag={'p'} className={'h6 PopReg text'} text={'Share'} />
                    <div className={`share-popup flexBox ${toggleSharePopup ? 'active' : ''}`}>
                        <Tooltip placement='top' title='twitter'>
                            <a href={twitterUrl} target='_blank'>
                                <Icon className='op-twitter' />
                            </a>
                        </Tooltip>
                        <Tooltip placement='top' title='linkedin'>
                            <a href={linkedinUrl} target='_blank'>
                                <Icon className='op-linkedin' />
                            </a>
                        </Tooltip>
                        <Tooltip placement='top' title='facebook'>
                            <a href={facebookUrl} target='_blank'>
                                <Icon className='op-facebook' />
                            </a>
                        </Tooltip>
                        <Tooltip placement='top' title='copy'>
                            <span onClick={() => copyTextToClipboard(url)} >
                                <Icon className='op-share1' />
                            </span>
                        </Tooltip>
                    </div>
                </ButtonSimple>
            </div>
        </TimerStyle>
    )
}

export default withUserContext(Timer, ['isLoggedIn', 'user', 'toggleFollow'])
